import { render } from "./FeesCreateForm.vue?vue&type=template&id=e8151d42"
import script from "./FeesCreateForm.vue?vue&type=script&lang=js"
export * from "./FeesCreateForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__